import {NgModule} from '@angular/core';
import {SharedModule} from '../../../core/shared.module';
import {WorkflowArticleStateComponent} from './workflow-article-state.component';

@NgModule({
  imports: [
    SharedModule,
  ],
  declarations: [
    WorkflowArticleStateComponent
  ],
  exports: [
    WorkflowArticleStateComponent
  ]
})
export class WorkflowPipesModule {
}
